import React, { useEffect, useRef } from "react";
import "./Logos.css";
import logos from "../../assets/logos.png"; // substitua pelo nome do seu arquivo

function Logos() {
  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let scrollAmount = 0;

    const scroll = () => {
      scrollAmount += 0.5; // velocidade do movimento
      if (scrollContainer) {
        if (scrollAmount >= scrollContainer.scrollWidth / 2) {
          scrollAmount = 0; // reinicia o loop
        }
        scrollContainer.scrollLeft = scrollAmount;
      }
      requestAnimationFrame(scroll);
    };

    scroll();

    return () => cancelAnimationFrame(scroll);
  }, []);

  return (
    <section className="logos-section">
      <div className="logos-container" ref={scrollRef}>
        <div className="logos-track">
          <img src={logos} alt="Logos de tecnologias" />
          <img src={logos} alt="Logos de tecnologias duplicadas" />
        </div>
      </div>
    </section>
  );
}

export default Logos;
